import CommonObj from "../../CommonObj";
import { encryptTimestamp } from "../commoncsrf/csrf-common";

const getHeaders = (accessToken) => ({
    Authorization: `Bearer ${accessToken || ""}`,
    "X-CSRF-Token": encryptTimestamp(),
    "Content-Type": "application/json",
});

export const getQcConfig = async ({ accessToken }) => {
    const response = await fetch(CommonObj.Endpoints.GetQCConfig, {
        method: "GET",
        headers: getHeaders(accessToken),
    });

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("text/html")) {
        throw new Error("QC config API returned HTML instead of JSON.");
    }

    if (!response.ok) {
        throw new Error("Network response was not ok");
    }

    const result = await response.json();

    if (typeof result === "number" || typeof result === "string") {
        return Number(result) === 1 ? 1 : 0;
    }

    if (typeof result === "object" && result !== null) {
        const directValue =
            result.isQcEnabled ??
            result.isQCEnabled ??
            result.qcEnabled ??
            result.QCEnabled;

        if (directValue !== undefined) {
            return Number(directValue) === 1 ? 1 : 0;
        }

        const wrappedValue =
            result.data?.isQcEnabled ??
            result.data?.isQCEnabled ??
            result.result?.isQcEnabled ??
            result.result?.isQCEnabled;

        if (wrappedValue !== undefined) {
            return Number(wrappedValue) === 1 ? 1 : 0;
        }
    }

    return 0;
};

export const updateQcConfig = async ({ accessToken, isQcEnabled }) => {
    const response = await fetch(CommonObj.Endpoints.UpdateQCConfig, {
        method: "POST",
        headers: getHeaders(accessToken),
        body: JSON.stringify({
            isQcEnabled: Number(isQcEnabled) === 1 ? 1 : 0,
        }),
    });

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("text/html")) {
        throw new Error("QC config update API returned HTML instead of JSON.");
    }

    if (!response.ok) {
        throw new Error("Failed to update QC config.");
    }

    return true;
};
